import React from "react";
import PropTypes from "prop-types";
import GridItemContainer from "../form-grids/GridItemContainer";
import Paper from "@material-ui/core/Paper";
import { Grid } from "@material-ui/core";
import "./FormContainerStyle.scss"


const FormContainer = React.forwardRef((props, ref) => {

  return (
    <GridItemContainer>
      <Grid item xs={12} sm={12} md={12} ref={ref}>
        <Paper className={"formContainer"} elevation={0}>
          {props.children}
        </Paper>
      </Grid>
    </GridItemContainer>
  );
});

FormContainer.propTypes = {
  children: PropTypes.node,
};

export default FormContainer;
